/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tb_Budget_TitleInputs */

const en_mk_tb_budget_title = /** @type {(inputs: Mk_Tb_Budget_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reserve a budget deliberately`)
};

const id_mk_tb_budget_title = /** @type {(inputs: Mk_Tb_Budget_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cadangkan anggaran secara sadar`)
};

/**
* | output |
* | --- |
* | "Reserve a budget deliberately" |
*
* @param {Mk_Tb_Budget_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tb_budget_title = /** @type {((inputs?: Mk_Tb_Budget_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tb_Budget_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tb_budget_title(inputs)
	return en_mk_tb_budget_title(inputs)
});